var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeskSvgrepocom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.30957H23.5",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.42041 5.30957V19.6896",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5899 10.0996H13.9199V14.8896H21.5899V10.0996Z",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5904 5.30957H13.9204V10.0996H21.5904V5.30957Z",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5801 19.6904V14.9004",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 7.22957V5.30957",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.75 12.0196V10.0996",
    stroke: "#9393B0",
    strokeWidth: 1.91997,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeskSvgrepocom);
export default __webpack_public_path__ + "static/media/desk_svgrepo.com.e9341a2bb1c2c3017aff0968e2b06b56.svg";
export { ForwardRef as ReactComponent };